import { Center } from '@zorro/web/design-system';
import React from 'react';

import { SVGIconProps } from '../types';

type Props = {
  style?: SVGIconProps;
  className?: string;
};

export const ElectionSubmitIcon = ({ style, className }: Props) => {
  return (
    <Center style={style} className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="147"
        height="57"
        viewBox="0 0 147 57"
        fill="none"
      >
        <rect
          width="144"
          height="36.3364"
          transform="translate(1.5 18.6682)"
          fill="white"
        />
        <rect
          x="0.75"
          y="18.0864"
          width="145.5"
          height="37.5"
          rx="4.75"
          stroke="#EDEFF6"
          strokeWidth="1.5"
        />
        <circle cx="72.458" cy="36.7056" r="11" fill="#C5C9F0" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M70.7383 41.6614L70.208 41.1261L69.6777 41.6614C69.9706 41.957 70.4454 41.957 70.7383 41.6614ZM70.208 40.0555L66.7383 36.5534C66.4454 36.2578 65.9706 36.2578 65.6777 36.5534C65.3848 36.8491 65.3848 37.3284 65.6777 37.624L69.6777 41.6614L70.208 41.1261C70.7383 41.6614 70.7383 41.6614 70.7383 41.6614L78.4559 33.8717C78.7487 33.5761 78.7487 33.0968 78.4559 32.8012C78.163 32.5055 77.6881 32.5055 77.3952 32.8012L70.208 40.0555Z"
          fill="white"
        />
        <path
          d="M86.458 23.7149L99.458 12.6121"
          stroke="url(#paint0_linear_3001_7237)"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M98.9722 38.7086L106.958 38.7086"
          stroke="url(#paint1_linear_3001_7237)"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <ellipse
          cx="2.5"
          cy="2.52336"
          rx="2.5"
          ry="2.52336"
          transform="matrix(-1 0 0 1 103.458 25.7336)"
          fill="url(#paint2_linear_3001_7237)"
        />
        <ellipse
          cx="1.5"
          cy="1.51402"
          rx="1.5"
          ry="1.51402"
          transform="matrix(-1 0 0 1 81.458 15.6401)"
          fill="url(#paint3_linear_3001_7237)"
        />
        <ellipse
          cx="1.5"
          cy="1.51402"
          rx="1.5"
          ry="1.51402"
          transform="matrix(-1 0 0 1 65.458 10.5934)"
          fill="url(#paint4_linear_3001_7237)"
        />
        <path
          d="M73.2227 12.5824L73.2228 1.00463"
          stroke="url(#paint5_linear_3001_7237)"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M60.001 23.7149L47.001 12.6121"
          stroke="url(#paint6_linear_3001_7237)"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <ellipse
          cx="49.501"
          cy="28.2569"
          rx="2.5"
          ry="2.52336"
          fill="url(#paint7_linear_3001_7237)"
        />
        <path
          d="M47.4858 38.7086L39.5005 38.7086"
          stroke="url(#paint8_linear_3001_7237)"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <defs>
          <linearGradient
            id="paint0_linear_3001_7237"
            x1="105.416"
            y1="13.0394"
            x2="101.334"
            y2="30.9063"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.00480769" stopColor="#8033EF" />
            <stop offset="0.551474" stopColor="#66D8F2" />
            <stop offset="0.9375" stopColor="#80E8B6" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_3001_7237"
            x1="108.719"
            y1="40.7088"
            x2="100.984"
            y2="45.4712"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.00480769" stopColor="#8033EF" />
            <stop offset="0.551474" stopColor="#66D8F2" />
            <stop offset="0.9375" stopColor="#80E8B6" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_3001_7237"
            x1="7.29167"
            y1="0.194212"
            x2="5.14092"
            y2="8.15879"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.00480769" stopColor="#8033EF" />
            <stop offset="0.551474" stopColor="#66D8F2" />
            <stop offset="0.9375" stopColor="#80E8B6" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_3001_7237"
            x1="4.375"
            y1="0.116527"
            x2="3.08455"
            y2="4.89527"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.00480769" stopColor="#8033EF" />
            <stop offset="0.551474" stopColor="#66D8F2" />
            <stop offset="0.9375" stopColor="#80E8B6" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_3001_7237"
            x1="4.375"
            y1="0.116527"
            x2="3.08455"
            y2="4.89527"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.00480769" stopColor="#8033EF" />
            <stop offset="0.551474" stopColor="#66D8F2" />
            <stop offset="0.9375" stopColor="#80E8B6" />
          </linearGradient>
          <linearGradient
            id="paint5_linear_3001_7237"
            x1="70.3734"
            y1="-1.42582"
            x2="63.6424"
            y2="10.1146"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.00480769" stopColor="#8033EF" />
            <stop offset="0.551474" stopColor="#66D8F2" />
            <stop offset="0.9375" stopColor="#80E8B6" />
          </linearGradient>
          <linearGradient
            id="paint6_linear_3001_7237"
            x1="41.0426"
            y1="13.0394"
            x2="45.1252"
            y2="30.9063"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.00480769" stopColor="#8033EF" />
            <stop offset="0.551474" stopColor="#66D8F2" />
            <stop offset="0.9375" stopColor="#80E8B6" />
          </linearGradient>
          <linearGradient
            id="paint7_linear_3001_7237"
            x1="54.2926"
            y1="25.9278"
            x2="52.1419"
            y2="33.8924"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.00480769" stopColor="#8033EF" />
            <stop offset="0.551474" stopColor="#66D8F2" />
            <stop offset="0.9375" stopColor="#80E8B6" />
          </linearGradient>
          <linearGradient
            id="paint8_linear_3001_7237"
            x1="37.739"
            y1="40.7088"
            x2="45.4738"
            y2="45.4712"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.00480769" stopColor="#8033EF" />
            <stop offset="0.551474" stopColor="#66D8F2" />
            <stop offset="0.9375" stopColor="#80E8B6" />
          </linearGradient>
        </defs>
      </svg>
    </Center>
  );
};
